import React, { useState, useEffect } from "react";
import { Button, Spin } from "antd";
// import { UpCircleOutlined } from "@ant-design/icons";
import { head, get, findIndex } from "lodash";

// import { Button } from './Styles';
import Task from "@pages/member-details/care-coordination/components/tasks/taskWithSubTask";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import { useHighIntensityProgramStore } from "@stores/highIntensityStore";
import "./HipDrawer.scss";
import CareCoordinationService from "@services/care-coordination";
import useSession from "@utils/useSession";
import { COMPLETE } from "@pages/member-details/care-coordination/constants";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
// import { CanEdit } from "@components/accessLevel";

const HipDrawer = () => {
  // const [hicProgram, setHicProgram] = useState<any>(null);
  const [loader, setLoader] = useState<boolean>(false);
  const [activeProgram, setActiveProgram] = useState<any>(null);
  const [searchSortedMemberLst, setSearchSortedMemberLst] = useState<any>([]);

  const session = useSession();

  const programsData = useCareCoordinationStore((state) => state.dataForCareCoordination);
  const setProgramsData = useCareCoordinationStore((state) => state.setDataForCareCoordination);
  const setPreviousDataForCareCoordination = useCareCoordinationStore((state) => state.setPreviousDataForCareCoordination);
  const setRules = useCareCoordinationStore((state) => state.setRules);
  // const setProgramOptions = useCareCoordinationStore((state) => state.setProgramOptions);
  // const setInterventionOptions = useCareCoordinationStore((state) => state.setInterventionOptions);
  // const assignedPrograms = useCareCoordinationStore((state) => state.assignedPrograms);
  const setAssignedPrograms = useCareCoordinationStore((state) => state.setAssignedPrograms);
  // const setInterventionDetailCollapse = useCareCoordinationStore((state) => state.setInterventionDetailCollapse);
  // const setUpdatedNotes = useCareCoordinationStore((state) => state.setUpdatedNotes);
  const driversList = useCareCoordinationStore((state) => state.driversList);
  const setDriversList = useCareCoordinationStore((state) => state.setDriversList);
  const selectedHipMember = useHighIntensityProgramStore((state) => state.selectedHipMember);
  const setSelectedHipMember = useHighIntensityProgramStore((state) => state.setSelectedHipMember);
  const hipMemberList = useHighIntensityProgramStore((state) => state.hipMemberList);
  const hipFilters = useHighIntensityProgramStore((state) => state.hipFilters);

  // setProgramsData(programData.data.program);

  useEffect(() => {
    setSearchSortedMemberLst(filteredSearchSortList);
  }, []);

  useEffect(() => {
    initialLoad({ patient_ID: selectedHipMember?.patient_id });
  }, [selectedHipMember?.patient_id]);

  const disableMemberChangeHandler = (flag: any) => {
    if (flag === "prev") {
      return findIndex(searchSortedMemberLst, { patient_id: selectedHipMember?.patient_id }) === 0;
    }
    return findIndex(searchSortedMemberLst, { patient_id: selectedHipMember?.patient_id }) === searchSortedMemberLst.length - 1;
  };

  const filteredSearchSortList = () => {
    return hipMemberList
      ?.filter((item: any) => (hipFilters?.searchText?.trim() !== "" ? item[hipFilters.searchDataIndex]?.toLowerCase()?.includes(hipFilters?.searchText?.toLowerCase()) : true))
      .sort((a: any, b: any) => {
        if (Number(a[hipFilters.sortDataIndex]) && Number(b[hipFilters.sortDataIndex])) {
          if (hipFilters.sortOrder === "ascend") {
            return Number(a[hipFilters.sortDataIndex]) && Number(b[hipFilters.sortDataIndex]) ? Number(a[hipFilters.sortDataIndex]) - Number(b[hipFilters.sortDataIndex]) : 0;
          }
          return Number(a[hipFilters.sortDataIndex]) && Number(b[hipFilters.sortDataIndex]) ? Number(b[hipFilters.sortDataIndex]) - Number(a[hipFilters.sortDataIndex]) : 0;
        }
        if (hipFilters.sortOrder === "ascend") {
          return a[hipFilters.sortDataIndex] && b[hipFilters.sortDataIndex] ? a[hipFilters.sortDataIndex].localeCompare(b[hipFilters.sortDataIndex]) : 0;
        }
        return a[hipFilters.sortDataIndex] && b[hipFilters.sortDataIndex] ? b[hipFilters.sortDataIndex].localeCompare(a[hipFilters.sortDataIndex]) : 0;
      });
  };

  const changeMemberHandler = (flag: any) => {
    if (flag === "prev") {
      setSelectedHipMember(searchSortedMemberLst.at(findIndex(searchSortedMemberLst, { patient_id: selectedHipMember?.patient_id }) - 1));
    } else {
      setSelectedHipMember(searchSortedMemberLst.at(findIndex(searchSortedMemberLst, { patient_id: selectedHipMember?.patient_id }) + 1));
    }
  };

  const getDrivers = (programId: any, patientProgramId: any) => {
    CareCoordinationService.fetchDriversList({ patientId: selectedHipMember?.patient_id, patientProgramId, programId }).subscribe({
      next: (v) => {
        const response = v?.data?.data;
        setDriversList(response);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  // const userTask = getFilteredTasks("userTask");
  // const otherUserTask = getFilteredTasks();

  const initialLoad = ({ patient_ID = selectedHipMember?.patient_id, programType = "HIC" }: any) => {
    // fetching info for a specific program
    setLoader(true);
    CareCoordinationService.fetchProgramDetails({ patientId: patient_ID, programType: programType }).subscribe({
      next: (v) => {
        const response = v.data;

        setRules(get(response, "data.rules", []));
        setProgramsData(get(response, "data.program", []));
        setActiveProgram(get(response, "data.program", []));
        setPreviousDataForCareCoordination(get(response, "data.program", []));
        setAssignedPrograms(get(response, "data.assignedPrograms", []));
        // stopping all the loaders over here
        // this timeout function has to be removed, rendering delay
        setTimeout(() => setLoader(false), 1000);
        getDrivers(get(response, "data.program.id", ""), get(response, "data.program.patientProgramId", ""));
      },
      error: (e) => {
        console.log(e);
        setLoader(false);
      },
    });
  };

  const getFilteredTasks = (type?: any) => {
    let tempTasks = get(head(get(programsData, "interventions", null)), "tasks", []);
    if (type === "userTask") {
      tempTasks = tempTasks.filter(
        (item: any) => driversList.filter((assigned: any) => assigned.assigneeValue?.toString() === session?.user?.id?.toString() && item.name === assigned?.reviewReasonLabel).length > 0
      );
    } else {
      tempTasks = tempTasks.filter(
        (item: any) => driversList.filter((assigned: any) => assigned.assigneeValue?.toString() !== session?.user?.id?.toString() && item.name === assigned?.reviewReasonLabel).length > 0
      );
    }
    return tempTasks;
  };

  const getProgramTaskStats = () => {
    const tempTasks = get(head(get(programsData, "interventions", null)), "tasks", []).filter(
      (item: any) =>
        driversList.filter(
          (assigned: any) =>
            assigned.assigneeValue?.toString() !== null &&
            assigned.assigneeValue?.toString() !== undefined &&
            assigned.assigneeValue?.toString()?.trim() !== "" &&
            item.name === assigned?.reviewReasonLabel
        ).length > 0
    );
    // return get(head(get(programsData, "interventions", null)), "tasks", []).length > 0 ? (
    return tempTasks?.length > 0 ? (
      <div className="hipDrawer__header__section-2__task-status">{`${tempTasks?.filter((item: any) => item.status === COMPLETE).length} / ${tempTasks?.length} Task Done`}</div>
    ) : null;
  };

  return (
    <>
      <Spin spinning={loader} indicator={<HealthemSpinner />}>
        {activeProgram ? (
          <>
            <div className="hipDrawer__header">
              <div className="hipDrawer__header__section-1">
                <div className="hipDrawer__header__section-1__arrow">
                  <Button
                    type="text"
                    shape="circle"
                    icon={<i className="icon icon-chevron-left" />}
                    size={"middle"}
                    className="profile-img-btn"
                    disabled={disableMemberChangeHandler("prev")}
                    onClick={() => changeMemberHandler("prev")}
                  />
                </div>
                <div className="hipDrawer__header__section-1__member">{selectedHipMember?.patient_name}</div>
                <div className="hipDrawer__header__section-1__arrow">
                  <Button
                    type="text"
                    shape="circle"
                    icon={<i className="icon icon-chevron-right" />}
                    size={"middle"}
                    className="profile-img-btn"
                    disabled={disableMemberChangeHandler("next")}
                    onClick={() => changeMemberHandler("next")}
                  />
                </div>
              </div>
              <div className="hipDrawer__header__section-2">{getProgramTaskStats()}</div>
            </div>
            <div className="hipDrawer custom-scroll-bar">
              <div className="hipDrawer__body">
                {/* {userTask ? ( */}
                <Task
                  programId={get(programsData, "id", null)}
                  interventionId={get(head(get(programsData, "interventions", null)), "id", null)}
                  tasks={getFilteredTasks("userTask")}
                  patientId={selectedHipMember?.patient_id}
                  patientProgramId={get(programsData, "patientProgramId", null)}
                  programName={get(programsData, "description", null)}
                  programEndDate={get(programsData, "endDate", null)}
                  updatedProgramEndDate={get(head(get(programsData, "interventions", null)), "endDate", null)}
                  taskGroupName={"My Tasks"}
                  showTaskGoals={true}
                  canEdit={true}
                  showAssignee={false}
                />
                {/* ) : null} */}
                {/* {otherUserTask ? ( */}
                <Task
                  programId={get(programsData, "id", null)}
                  interventionId={get(head(get(programsData, "interventions", null)), "id", null)}
                  tasks={getFilteredTasks()}
                  patientId={selectedHipMember?.patient_id}
                  patientProgramId={get(programsData, "patientProgramId", null)}
                  programName={get(programsData, "description", null)}
                  programEndDate={get(programsData, "endDate", null)}
                  updatedProgramEndDate={get(head(get(programsData, "interventions", null)), "endDate", null)}
                  taskGroupName={"Care Team Tasks"}
                  showTaskGoals={true}
                  canEdit={false}
                  showAssignee={true}
                />
                {/* ) : null} */}
              </div>
              {/* <div className="hipDrawer__footer">footer</div> */}
            </div>
          </>
        ) : null}
      </Spin>
    </>
  );
};

export default HipDrawer;
